import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
import ImageUploading from 'react-images-uploading';
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { addExhibitorSubscription, getSingleSubscription } from '../../Service';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useSelector} from 'react-redux';

export default function ExhibitorSubscribe() {

    const { subscription_id } = useParams();
    const navigation = useNavigate();
    const [subscriptionData, setSubscriptionData] = useState([]);
    const [success, setSuccess] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);
    const loggedUser = useSelector(store => store.user.user)
    const user_id = loggedUser.id
    
    useEffect(() => {
        let params = { 'id': subscription_id };
        getSingleSubscription(params).then(res => handleSingleResponse(res))
      }, []);

      const handleSingleResponse = (response) => {
        if(response.data.code==400){ //IF Token Expired......
            const errors = {};
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: response.data.message,
            })
          }else if(response.data.code==200){  //IF Request is Success
            setSubscriptionData(response.data.data.subscription.items[0]);
          }
      } 

          // creates a paypal order
 const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "Photola Payment",
            amount: {
              currency_code: "USD",
              //value: subscriptionData.sub_price
              value: 1,
            },
          },
        ],
        // not needed if a shipping address is actually needed
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };

   // check Approval
   const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      setSuccess(true);
    });
  };


  //capture likely error
  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };
 
  useEffect(() => {
   if (success) {
     console.log("success",success);
     var bodyFormData = new FormData();
     bodyFormData.append('user_id', user_id);
     bodyFormData.append('subscription_id', subscription_id);
     //bodyFormData.append('amount', subscriptionData.sub_price);
     bodyFormData.append('amount', 1);
     bodyFormData.append('validity', subscriptionData.sub_validity);
     bodyFormData.append('orderid', orderID);
     bodyFormData.append('status', success);
     if(success){
        addExhibitorSubscription(bodyFormData).then(res => handleResponse(res))
     }else{
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: "Failed Payment",
          })
     }
     
   }
 },
 [success]
 );

 

 const handleResponse = (res) => 
      {
        
        if(res.status==200)
        {
          Swal.fire({
            position: 'center',
            icon: 'success',
            text: 'Paid Successfully!. Pending approval from Site Administrator.',
            showConfirmButton: true,
          })
            navigation("/thanks/");
        }
        else
        {
            navigation('/exhibitor-subscription/'+subscription_id);
        }
      }
 
 console.log(1, orderID);
 console.log(2, success);
 console.log(3, ErrorMessage);
    

    return(
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="admin-edit gallery-guide">
                        <h1>{subscriptionData.sub_name} - 
                        
                        {(() => {
                                    if(subscriptionData.sub_validity==1){
                                        return (
                                            <>[Annually]</>
                                        )
                                    }else if(subscriptionData.sub_validity==2){
                                        return (
                                            <>[Half-Yearly]</>
                                        )
                                    }else if(subscriptionData.sub_validity==3){
                                        return (
                                            <>[Quarterly]</>
                                        )
                                    }else if(subscriptionData.sub_validity==4){
                                        return (
                                            <>[Monthly]</>
                                        )
                                    }
                                })()}
                        </h1>
                          <div className='gry-bg'>
                               <h3> Subscription Details: </h3>
  
                                
                                <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt 
                                ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation 
                                ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in 
                                reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint 
                                occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est 
                                laborum. 
                               
                            </p> </div>
                            



            <div style={{"width":"100%"}} >
            <div className='table-responsive'>
<h1>Payment Details</h1>
<Table>
<thead>
<tr>
<th>Item</th>
 <th>Price</th>
{/* <th>Due Now</th> */}

        </tr>

      </thead>

      <tbody>

        

        <tr>

        <td>{subscriptionData.sub_name} - 
              {(() => {
                  if(subscriptionData.sub_validity==1){
                      return (
                          <>Annually</>
                      )
                  }else if(subscriptionData.sub_validity==2){
                      return (
                          <>Half-Yearly</>
                      )
                  }else if(subscriptionData.sub_validity==3){
                      return (
                          <>Quarterly</>
                      )
                  }else if(subscriptionData.sub_validity==4){
                      return (
                          <>Monthly</>
                      )
                  }
              })()}
        </td>

        <td>$ {subscriptionData.sub_price}</td>

        </tr>

        <tr>

        <td colSpan={1}>Total </td>

        <td><strong>$ {subscriptionData.sub_price}</strong></td>

         

        </tr>        

      </tbody>

    </Table>

        </div>
        <br />
            </div> 

            <PayPalScriptProvider
     options={{
       //"client-id":"AVWU88u7CUsbc3A6QhVV84NGTQTXaodgJVAKy_--zrr7oLomTXZIuTlf8A06oF3acW2LGygIoHjVjlh1",
       "client-id":"AUGh7pFdOxYIKIJR7vfhteW1AtcHk9oyEzUmjjoqMdJDxcmNdKUWcd3qBeJZzJXcGLNw67KtXl5OSEKK",
     }}
   >

 
     
         <PayPalButtons style={{ layout: "vertical" }} createOrder={createOrder} onApprove={onApprove} />


   </PayPalScriptProvider>                       



                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}